import { toast } from 'fitify-ui/src/Toast'
import { useAuthUserContext } from 'fitify-ui-onboarding/src/contexts/AuthUserContext'
import { useRouter } from 'fitify-ui-onboarding/src/hooks/useRouter'
import { useCallback } from 'react'

import { APP_PAGES } from 'data/routes'

export const useLogout = () => {
  const router = useRouter()
  const { logout } = useAuthUserContext()

  const handleLogout = useCallback(async () => {
    try {
      await logout()
      void router.push(APP_PAGES.home.path)
    } catch (err) {
      console.error(err)
      toast({ type: 'error', content: 'Failed to log out' })
    }
  }, [logout, router])

  return {
    handleLogout,
  }
}
